import {$isLinkNode} from '@lexical/link';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {$findMatchingParent} from '@lexical/utils';
import {$getSelection, $isRangeSelection, CLICK_COMMAND, COMMAND_PRIORITY_LOW} from 'lexical';
import {match} from 'ts-pattern';

import {useRef} from 'react';

import {isURLDangerous, useOnMount} from 'shared/web';

import {getSelectedNode} from '../utils/getSelectedNode';

export const OpenLinkPlugin = () => {
  const [editor] = useLexicalComposerContext();
  const unregister = useRef<VoidFunction | null>(null);

  useOnMount(
    () => {
      unregister.current = editor.registerCommand(
        CLICK_COMMAND,
        (payload) => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            const node = getSelectedNode(selection);
            const linkNode = $findMatchingParent(node, $isLinkNode);
            if ($isLinkNode(linkNode) && (payload.metaKey || payload.ctrlKey)) {
              const url = linkNode.getURL();

              match(url)
                .when(isURLDangerous, () => undefined)
                .when(
                  (value) => value.startsWith('mailto:'),
                  (value) => {
                    window.location.href = value;
                  }
                )
                .otherwise((value) => {
                  window.open(value, '_blank', 'noopener');
                });

              return true;
            }
          }
          return false;
        },
        COMMAND_PRIORITY_LOW
      );
    },
    () => unregister.current?.()
  );

  return null;
};
